import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    $(this.element).modal('show')

    $(this.element).on("hidden.bs.modal", () => {
      this.element.remove()
    })
  }
}
